import { render, staticRenderFns } from "./CreatePersonForm.vue?vue&type=template&id=517d3d76&scoped=true"
import script from "./CreatePersonForm.vue?vue&type=script&lang=js"
export * from "./CreatePersonForm.vue?vue&type=script&lang=js"
import style0 from "./CreatePersonForm.vue?vue&type=style&index=0&id=517d3d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d3d76",
  null
  
)

export default component.exports